import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default function HomeLine1(props) {
    return (
        <SvgIcon {...props} viewBox="0 0 78 116" style={{ width: '8%', height: '100%' }}>
            <svg fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M76.7417 1.98841L76.7408 71.3533L1.00421 114.853" stroke="#F9A237" strokeWidth="2" strokeLinecap="round" strokeDasharray="4 8"/>
            </svg>
        </SvgIcon>
    );
}
